export default "__VITE_ASSET__D9oki20V__"